import { useState } from "react";
import { toast } from "sonner";
import { API } from "@/lib/api";
import { readJson } from "./adminApi";

export const useBatchLifecycle = ({ key, authFetch, rowsCount, setBatchInput, reload }) => {
  const [pastTotal, setPastTotal] = useState(0);
  const [startingBatch, setStartingBatch] = useState(false);
  const [archiving, setArchiving] = useState(false);

  const refreshPastTotal = async () => {
    try {
      const res = await fetch(`${API}/admin/past-participants`, { headers: { "X-PL-Client": "web", "X-Admin-Key": key } });
      if (res.ok) { const d = await res.json(); setPastTotal(d.total || 0); }
    } catch (err) {
      console.warn("Could not refresh past participants total", err);
    }
  };

  const archiveBatch = async () => {
    if (rowsCount === 0) { toast.error("No registrations to archive"); return; }
    if (!window.confirm(`Archive all ${rowsCount} current registration(s) into Past Batch? The registration list stays as-is and Batch# does not change.`)) return;
    setArchiving(true);
    try {
      const res = await authFetch(`/admin/past-participants/archive`, { method: "POST" });
      const data = await readJson(res);
      if (!res.ok) throw new Error(data?.detail || "Archive failed");
      toast.success(`Archived ${data.archived} participant(s). Past total: ${data.past_total}`);
      refreshPastTotal();
    } catch (err) {
      toast.error(err.message || "Archive failed");
    } finally {
      setArchiving(false);
    }
  };

  const startNewBatch = async () => {
    if (!window.confirm(`Start a new batch? All ${rowsCount} current registration(s) will be saved into the Past Batch database and the registration list will be emptied.`)) return;
    if (!window.confirm("Are you sure? Batch# will increase by 1 and fresh registrations will start under the new batch.")) return;
    setStartingBatch(true);
    try {
      const res = await authFetch(`/admin/start-new-batch`, { method: "POST" });
      const data = await readJson(res);
      if (!res.ok) throw new Error(data?.detail || "Failed");
      toast.success(`New batch started: ${data.batch_no}. Saved ${data.archived} participant(s); registration list cleared.`);
      setBatchInput(data.batch_no || "");
      await reload();
    } catch (err) {
      toast.error(err.message || "Failed to start new batch");
    } finally {
      setStartingBatch(false);
    }
  };

  const uploadPast = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;
    const fd = new FormData();
    fd.append("file", file);
    try {
      const res = await fetch(`${API}/admin/past-participants/upload`, { method: "POST", headers: { "X-PL-Client": "web", "X-Admin-Key": key }, body: fd });
      const data = await readJson(res);
      if (!res.ok) throw new Error(data?.detail || "Upload failed");
      toast.success(`Past participants — added: ${data.added}, updated: ${data.updated}, skipped: ${data.skipped}. Total saved: ${data.total}`);
      refreshPastTotal();
    } catch (err) {
      toast.error(err.message || "Upload failed");
    }
  };

  return { pastTotal, setPastTotal, refreshPastTotal, archiveBatch, archiving, startNewBatch, startingBatch, uploadPast };
};
